import React, { useContext } from "react";
import "./DeliveryTracker.css";
import { t } from "i18next";
import { LoaderContext } from "../../AuthContext/AuthContext";

const DeliveryTracker = ({ statusData, stepMap, moduleName }) => {
    // Define all steps and their corresponding backend keys

 const { selectedLanguageID } = useContext(LoaderContext);
    // Create full steps array (even if dates are null)
    const steps = (() => {
        const isEStore = moduleName === 'EStore';

        const allSteps = isEStore
            ? [
                { key: "bookingDate", label: t("Booked") },
                { key: "confirmedDate", label: t("Confirmed") },
                { key: "processingDate", label: t("Processed") },
                // { key: "onTheWayDate", label: t("En-Route") },
                { key: "deliveredDate", label: t("Delivered") },
            ]
            : [
                { key: "bookingDate", label: t("Processed") },
                { key: "confirmedDate", label: t("Confirmed") },
                { key: "completedDate", label: t("Completed") },
            ];

        // Handle Cancelled
        if (statusData.cancelledDate) {
            return [
                {
                    key: "processed",
                    label: t("Processed"),
                    date: statusData.bookingDate || null
                },
                {
                    key: "cancelled",
                    label: t("Cancelled"),
                    date: statusData.cancelledDate
                }
            ];
        }

        // Handle Rejected
        if (statusData.rejectedDate) {
            return [
                {
                    key: "processed",
                    label: t("Processed"),
                    date: statusData.bookingDate || null
                },
                {
                    key: "rejected",
                    label: t("Rejected"),
                    date: statusData.rejectedDate
                }
            ];
        }

        // Default flow: map all steps
        return allSteps.map(({ key, label }) => ({
            key: label.toLowerCase(),
            label: ` ${label}`,
            date: statusData[key] || null
        }));
    })();




    // Find the current step index (last step that has a date)
    const currentIndex = steps?.reduce((lastIdx, step, idx) => {
        return step?.date ? idx : lastIdx;
    }, -1);

    return (
        <div className="tracker-wrapper">
            <h5 className={`card-title text-center mb-2 fw-bold ${selectedLanguageID===3 && 'other-marathi-content '}`}>{t("Order Status")}</h5>
            <div className={`${moduleName === 'EStore' ? 'stepper-product' : 'stepper'}`}  >
                {steps.map((step, index) => {
                    const isCompleted = index <= currentIndex;
                    const isLineActive = index < currentIndex;

                    return (
                        <div key={step.key} className="step-item">
                            <div className={`step-icon ${isCompleted ? "active" : ""}`}>
                                {isCompleted ? "✔" : ""}
                            </div>
                            <div className={`step-label ${isCompleted ? "active" : ""}`}>
                                <span>{t(step.label)}</span> <br />
                                <span style={{ fontSize: "10px" }}>
                                    {step.date || "Pending"}
                                </span>
                            </div>
                            {index < steps.length - 1 && (
                                <div
                                    className={`${moduleName === 'EStore' ? ' step-line-custom-product' : 'step-line-custom'} width-custom ${isLineActive ? "active" : ""}`}
                                    style={{ right: "-50%", left: "50%" }}
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default DeliveryTracker;
